namespace Areas.Attachment {
    "use strict";

    const attachmentGridId = "attachmentDataGrid";
    const attachmentGridKey = "attachmentId";
    const fileUploaderId = "fileUploaderControl";
    const textBoxId = "FileDescriptionTextBox";

    export function onValueChanged(e) {
        var newValue = e.value;
        if (newValue != e.previousValue) {
            var uploader = $("#fileUploaderControl").dxFileUploader("instance");
            var url = uploader.option("uploadUrl");
            url = updateQueryStringParameter(url, "fileDescription", newValue);
            uploader.option("uploadUrl", url);
        }
    }

    export function onUploadError(e) {
        DevExpress.ui.notify(e.error.responseText, "error", 2000);
    }

    export function addIconImage(cellElement, cellInfo) {
        var iconSource = cellInfo.data.icon;
        var img = "<img src='" + String(iconSource) + "'/>";
        cellElement.height(30);
        cellElement.html(img);
    }

    export function downloadAttachmentLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.attachmentId; },
            "<a href= '/File/Get/Attachment/{placeholder}'>Download</a>");
    }

    export function refreshGridAfterUpload(e) {
        Areas.refreshGrid(attachmentGridId);
    }

    export function onCellPrepared(e) {

        if (e.rowType === "data" && e.column.command === "edit") {
            if (e.data.isReadOnly) {
                e.cellElement.empty();
            }
        }
    }

    export function updateAttachmentControls(recordId: number, parentEntity: string, fileDescription: string = "") {
        updateUploadControl(recordId, fileDescription);
        updateGridControl(recordId, parentEntity);
    }

    export function updateUploadControl(recordId: number, fileDescription: string) {
        const uploader = getFileUploader();

        if (uploader) {
            if (recordId > 0) {

                let url = uploader.option("uploadUrl");
                url = updateQueryStringParameter(url, "recordId", recordId);
                url = updateQueryStringParameter(url, "fileDescription", fileDescription);
                uploader.option("uploadUrl", url);
            }
        }

        const textBoxControl = getFileUploaderTextBox();
        if (textBoxControl) {
            textBoxControl.option("value", fileDescription);
        }
    }



    export function updateGridControl(recordId: number, parentEntity: string) {
        const uploadGrid = getAttachmentGrid();

        if (uploadGrid) {
            uploadGrid.option("dataSource", createDataSource(recordId, parentEntity));
        }
    }

    function createDataSource(recordId: number, parentEntity: string): DevExpress.data.DataSource {
        const baseUrl = "/Attachment/Attachment";

        const storeConfiguration = {
            "loadParams": {
                recordId: recordId,
                parentEntity: parentEntity
            },
            "key": attachmentGridKey,
            "loadUrl": `${baseUrl}/Get`,
            "insertUrl": `${baseUrl}/Post`,
            "updateUrl": `${baseUrl}/Put`,
            "deleteUrl": `${baseUrl}/Delete`
        };

        const store = DevExpress.data.AspNet.createStore(storeConfiguration);
        return new DevExpress.data.DataSource({ store: store });
    }

    function getAttachmentGrid(): DevExpress.ui.dxDataGrid {
        return Areas.getGrid(attachmentGridId);
    }

    function getFileUploader(): DevExpress.ui.dxFileUploader {
        return $(`#${fileUploaderId}`).dxFileUploader("instance");
    }

    function getFileUploaderTextBox(): DevExpress.ui.dxTextBox {
        return $(`#${textBoxId}`).dxTextBox("instance");
    }
}                                                                      